import { ElementRef, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { getContactsRowsSelector, getContactsColsSelector, getContactsTotalSelector, getContactsPageSelector, getTempPageSelector, getExpandedListSelector, getTempEditedFiltersSelector } from '../contacts.reducer';
import { UpdateColumnsAction, SetFilterTagsAction, ClearPageOffsetAction } from '../contacts.actions';
import { ContactsService } from '../shared/services/contacts.service';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DATETIME_FORMATS } from '../../shared/utils/timeUtils';
import { DatePickerService } from '../../shared/services/date.picker.service';
var EventsTableComponent = /** @class */ (function () {
    function EventsTableComponent(store, contactsService, datePickerService, translate) {
        this.store = store;
        this.contactsService = contactsService;
        this.datePickerService = datePickerService;
        this.translate = translate;
        this.selected = [];
        this.swapColumns = false;
        this.paginationOptions = [10, 20, 50, 100];
        this.utcOffset = moment().utcOffset();
        this.maxDate = moment().add(this.utcOffset / 60, 'hours').toISOString();
        this.minDetailHeight = 530;
        this.scrollWidth = 6;
    }
    EventsTableComponent.prototype.onResize = function (event) {
        this.innerWidth = window.innerWidth;
        if (this.innerWidth <= 1500) {
            this.columnWidth = 170;
        }
        else if (this.innerWidth <= 1750 && this.innerWidth > 1500) {
            this.columnWidth = 190;
        }
        else if (this.innerWidth <= 1860 && this.innerWidth > 1750) {
            this.columnWidth = 200;
        }
        else {
            this.columnWidth = 230;
        }
    };
    EventsTableComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.onResize(event);
        this.filterParams = {
            filter: {
                dateFrom: moment()
                    .subtract(7, 'day')
                    .toISOString(),
                dateTo: moment().toISOString(),
                contactId: null,
                users: []
            },
            pagination: {
                limit: 10,
                offset: 0,
                sortBy: null,
                order: null
            }
        };
        this.store.select(getContactsRowsSelector).subscribe(function (contacts) {
            _this.rows = contacts;
        });
        this.store.select(getContactsColsSelector).subscribe(function (columns) {
            _this.columns = columns;
        });
        this.store.select(getContactsTotalSelector).subscribe(function (total) {
            _this.total = total;
        });
        this.store.select(getContactsPageSelector).subscribe(function (page) {
            _this.page = page;
        });
        this.store.select(getExpandedListSelector).subscribe(function (expandedList) {
            _this.expandedList = expandedList;
        });
        this.store.select(getTempPageSelector).subscribe(function (tempPage) {
            _this.tempPageFilters = tempPage;
            if (tempPage) {
                _this.filterParams = tempPage;
                _this.dateDateView = _this.getRangeTagName({
                    dateFrom: moment(_this.filterParams.filter.dateFrom).toISOString(),
                    dateTo: _this.filterParams
                        ? moment(_this.filterParams.filter.dateTo).toISOString()
                        : moment().toISOString()
                });
                _this.startDate = moment(_this.filterParams.filter.dateFrom).toISOString();
                _this.endDate = moment(_this.filterParams.filter.dateTo).toISOString();
                _this.tableOffset = _this.filterParams.pagination.offset / _this.filterParams.pagination.limit;
            }
        });
        this.contactsService.useFilters.subscribe(function () {
            _this.onUseFilters();
        });
        this.translate.get('CONTACTS_LIST.NO_DATA_FOUND').subscribe(function (text) {
            _this.emptyMessage = text;
            _this.messages = {
                emptyMessage: "<div class=\"empty-message\"><span>" + _this.emptyMessage + "</span></div>"
            };
        });
        this.translate.onLangChange.subscribe(function (event) {
            _this.messages = {
                emptyMessage: "<div class=\"empty-message\"><span>" + event.translations.CONTACTS_LIST.NO_DATA_FOUND + "</span></div>"
            };
        });
        this.store.select(getTempEditedFiltersSelector).subscribe(function (tempEditedFiltersList) {
            _this.tempEditedFiltersList = tempEditedFiltersList;
        });
        this.maxDate = moment().add(this.utcOffset / 60, 'hours').toISOString();
        this.contactsService.fetchDataAction(this.filterParams, 0);
    };
    EventsTableComponent.prototype.onActivate = function (event) {
        this.activeEvent = event.row.event_id;
    };
    EventsTableComponent.prototype.getRowIdentity = function (row) {
        return row.NATIVE_RECORD_ID;
    };
    EventsTableComponent.prototype.onSelect = function (_a) {
        var selected = _a.selected;
        var _b;
        this.selected.splice(0, this.selected.length);
        (_b = this.selected).push.apply(_b, selected);
    };
    EventsTableComponent.prototype.add = function () {
        this.selected.push(this.rows[1], this.rows[3]);
    };
    EventsTableComponent.prototype.update = function () {
        this.selected = [this.rows[1], this.rows[3]];
    };
    EventsTableComponent.prototype.remove = function () {
        this.selected = [];
    };
    EventsTableComponent.prototype.displayCheck = function (row) {
        // when want to have some already check by default (uncheckable)
        // return row.userName !== 'Some User Name';
    };
    EventsTableComponent.prototype.onSort = function (event) {
        var colName = event.sorts[0].prop.startsWith('NATIVE')
            ? event.sorts[0].prop.replace('NATIVE_', '')
            : event.sorts[0].prop.startsWith('IMPORTED') ? event.sorts[0].prop.replace('IMPORTED_', '') : event.sorts[0].prop;
        this.filterParams.pagination.sortBy =
            colName === 'DETAILS' ? 'NAME' : colName === 'AGENT' ? 'CREATOR_LOGIN' : colName;
        this.filterParams.pagination.order = event.sorts[0].dir.toUpperCase();
        this.filterParams.pagination.offset = 0;
        this.contactsService.fetchDataAction(this.filterParams);
    };
    EventsTableComponent.prototype.toggleChecking = function (col) {
        var isChecked = this.isChecked(col);
        if (isChecked) {
            this.columns = this.columns.filter(function (c) {
                return c.key !== col.key;
            });
        }
        else {
            this.columns = this.columns.concat([col]);
        }
        this.store.dispatch(new UpdateColumnsAction(this.columns));
    };
    EventsTableComponent.prototype.isChecked = function (col) {
        return this.columns.find(function (c) {
            return c.key === col.key;
        });
    };
    EventsTableComponent.prototype.setPage = function (pageInfo) {
        this.filterParams.pagination.offset = pageInfo.offset * this.filterParams.pagination.limit;
        this.contactsService.fetchDataAction(this.filterParams);
    };
    EventsTableComponent.prototype.changePagination = function (event) {
        this.filterParams.pagination.offset = 0;
        this.filterParams.pagination.limit = event.value;
        this.contactsService.fetchDataAction(this.filterParams);
    };
    EventsTableComponent.prototype.onUseFilters = function () {
        this.store.dispatch(new ClearPageOffsetAction(0));
        this.store.dispatch(new SetFilterTagsAction());
        this.contactsService.fetchDataAction(this.tempPageFilters, 0);
    };
    EventsTableComponent.prototype.changeDateRange = function (event) {
        this.contactsService.onChangeRange(event);
        this.contactsService.fetchDataAction(this.tempPageFilters);
    };
    EventsTableComponent.prototype.getRangeTagName = function (rangeFilter) {
        var dateFrom = "" + moment(rangeFilter.dateFrom).format('L');
        var dateTo = "" + moment(rangeFilter.dateTo).format('L');
        return dateFrom === dateTo ? dateTo : dateFrom + " - " + dateTo;
    };
    EventsTableComponent.prototype.getDateFormated = function (date) {
        return moment(date).format(DATETIME_FORMATS.us);
    };
    EventsTableComponent.prototype.getEventTypeLabel = function (statusName) {
        return this.contactsService.getEventTypeLabel(statusName);
    };
    EventsTableComponent.prototype.getCallLengthLabel = function (callLength) {
        var minutes = Math.floor(callLength / 60);
        var seconds = callLength - minutes * 60;
        return minutes === 0 && seconds === 0 ? '-' : minutes + "min " + seconds + "sec";
    };
    EventsTableComponent.prototype.buttonClick = function (event) {
        //future feature event
    };
    EventsTableComponent.prototype.openPicker = function () {
        this.datePickerService.toggleDatePicker({
            open: 'right',
            show: true,
            positionX: this.iconCalendar.nativeElement.offsetLeft,
            positionY: this.iconCalendar.nativeElement.offsetTop
        });
    };
    EventsTableComponent.prototype.addFilter = function () {
        this.contactsService.showFilters();
        this.contactsService.showSearchFilters();
        this.contactsService.snapshotCallFinishType();
    };
    EventsTableComponent.prototype.getRelatedContactNames = function (relatedContacts) {
        var _this = this;
        return relatedContacts.map(function (contact) {
            return _this.getContactNamePhrase(contact);
        });
    };
    EventsTableComponent.prototype.getContactNamePhrase = function (contact) {
        return "" + (contact.firstName ? ' ' + contact.firstName : 'UNKNOWN') + (contact.lastName ? ' ' + contact.lastName : '');
    };
    return EventsTableComponent;
}());
export { EventsTableComponent };
